import { render, staticRenderFns } from "./BackComponent.vue?vue&type=template&id=03e3783a&scoped=true&"
import script from "./BackComponent.vue?vue&type=script&lang=js&"
export * from "./BackComponent.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "03e3783a",
  null
  ,true
)

export default component.exports